/**
 * QUEM ESTÁ LOGADO, LEGÍVEL SEM HOOK.
 *
 * ═══ POR QUE NÃO É UM HOOK (02/09/2026) ════════════════════════════════════
 * Quem lê isto é o `ErroDados` — o componente que aparece QUANDO ALGO JÁ DEU
 * ERRADO. Ele decide por papel se mostra o detalhe técnico do erro. Duas razões
 * pesadas para ele não depender do contexto de auth:
 *
 * 1. **Ele não pode ter como falhar.** `useAuth` lança fora do provider. Um
 *    componente de erro que lança derruba a árvore do React, e a pessoa fica
 *    com tela branca em vez da mensagem de erro — troca um problema por um
 *    pior, exatamente no pior momento.
 *
 * 2. **57 arquivos de teste substituem o módulo `hooks/useAuth` inteiro** (com
 *    `vi.mock`). Um import novo lá dentro quebraria todos de uma vez, e o
 *    conserto seria editar 57 arquivos para adicionar uma função que eles não
 *    usam. Guardrail bom não cobra pedágio de quem não passa por ali.
 *
 * O padrão é o mesmo que `api.ts` já usa para a empresa ativa e para a lente
 * "ver como": um holder de módulo, vivo nesta aba, escrito por quem sabe.
 *
 * ⚠️ NÃO use isto para decidir ACESSO. Papel de verdade quem confere é a API,
 * com o JWT, e a RLS no banco — este valor mora no navegador e serve só para
 * escolher o que DESENHAR. Aqui ele decide mostrar ou não um texto de erro que
 * o servidor já mandou para esta mesma pessoa.
 */
export type Papel = "admin" | "encarregado" | "cliente";

let papel: Papel | undefined;

/** Chamado pelo `AuthProvider` quando o usuário entra, muda ou sai. */
export function definirPapelAtual(p: Papel | undefined): void {
  papel = p;
}

/** `undefined` antes do login, depois do logout e em teste — o lado seguro. */
export function papelAtual(): Papel | undefined {
  return papel;
}
